<template>
  <v-app class="white">
    <v-app-bar class="hidden-sm-and-down newHeader" app fixed id="headerStyle" >
      <router-link to="/" style="textdecoration: none">
        <v-list-item>
          <img class="logo" src="./assets/logo-my-pa-box-white.svg" />
        </v-list-item>
      </router-link>

      <!-- Home  -->

      <!-- Dashoard -->
      <router-link class="newHeader__link" to="/dashboard">
        <v-list-item>
          <v-list-item-icon class="iconShortSpace"
            ><v-icon>mdi-view-dashboard</v-icon></v-list-item-icon
          >
          <v-list-item-content
            ><v-list-item-title
              >My Dashboard</v-list-item-title
            ></v-list-item-content
          >
        </v-list-item>
      </router-link>

      <!-- PA Schools -->
      <router-link class="newHeader__link" to="/paschools">
        <v-list-item>
          <v-list-item-icon class="iconShortSpace"
            ><v-icon>mdi-school</v-icon></v-list-item-icon
          >
          <v-list-item-content
            ><v-list-item-title
              >PA Schools</v-list-item-title
            ></v-list-item-content
          >
        </v-list-item>
      </router-link>

      <!-- School Match -->
      <router-link class="newHeader__link" to="/paschoolfinder">
        <v-list-item>
          <v-list-item-icon class="iconShortSpace"
            ><v-icon>mdi-target</v-icon></v-list-item-icon
          >
          <v-list-item-content
            ><v-list-item-title
              >School Match</v-list-item-title
            ></v-list-item-content
          >
        </v-list-item>
      </router-link>

      <!-- Services  -->
      <router-link class="newHeader__link" to="/services">
        <v-list-item>
          <v-list-item-icon class="iconShortSpace"
            ><v-icon>mdi-face-agent</v-icon></v-list-item-icon
          >
          <v-list-item-content
            ><v-list-item-title
              >Services</v-list-item-title
            ></v-list-item-content
          >
        </v-list-item>
      </router-link>

       <!-- Blog -->
      <a  class="newHeader__link" href="https://blog.mypabox.com/">
        <v-list-item>
          <v-list-item-icon class="iconShortSpace"
            ><v-icon>mdi-post-outline</v-icon></v-list-item-icon
          >
          <v-list-item-content
            ><v-list-item-title
              >Blog</v-list-item-title
            ></v-list-item-content
          >
        </v-list-item>
      </a>

      <v-layout column align-end justify-end>
        <div class="actionContainer">
          <!-- Login Button -->
          <v-list-item
            v-if="user === null || user === undefined"
            @click="showLoginSignUpScreen"
          >
            <v-list-item-icon class="iconShortSpace"
              ><v-icon>mdi-power</v-icon></v-list-item-icon
            >
            <v-list-item-content
              ><v-list-item-title>Login</v-list-item-title></v-list-item-content
            >
          </v-list-item>
          <!-- Profile Button -->
          <v-list-item
            v-if="user !== null && user !== undefined"
            @click="showAccountScreen"
          >
            <v-list-item-icon class="iconShortSpace"
              ><v-icon>mdi-account-circle</v-icon></v-list-item-icon
            >
            <v-list-item-content
              ><v-list-item-title
                >Profile</v-list-item-title
              ></v-list-item-content
            >
          </v-list-item>

          <!-- Logout Button -->
          <v-list-item
            v-if="user !== null && user !== undefined"
            @click="logout"
          >
            <v-list-item-icon class="iconShortSpace"
              ><v-icon>mdi-power</v-icon></v-list-item-icon
            >
            <v-list-item-content
              ><v-list-item-title
                >Logout</v-list-item-title
              ></v-list-item-content
            >
          </v-list-item>
        </div>
      </v-layout>
    </v-app-bar>
    <v-content class="white">
      <v-container class="white content">
        <keep-alive
          :exclude="[
            'SchoolDetail',
            'Services',
            'ServicesDetails',
            'ServiceDetail',
          ]"
        >
          <user-profile-questions
            v-if="user && !user.user_profile && validSubscription"
          ></user-profile-questions>
          <v-layout
            v-else-if="schools.length <= 0"
            column
            align-center
            justify-center
            mt-10
          >
         
             <img id="loadingLogo" src="./assets/logo_color_horizontal.svg" />
            
            <v-progress-circular
              :size="100"
              color="primary"
              indeterminate
              class="mt-5"
            ></v-progress-circular>
            <span class="mt-2 subheading font-weight-regular grey--text"
              >Loading...</span
            >
          </v-layout>
          <router-view :key="$route.fullPath" v-else></router-view>
        </keep-alive>
      </v-container>
      
    </v-content>

    <!-- Mobile Bottom Navigation -->
    <v-bottom-navigation
      class="hidden-md-and-up mobile__toolbar"
      v-if="showMenuBar"
      background-color="#191340"
      dark
      fixed
      app
      grow
    >
      <!-- Home Button -->
      <v-btn text to="/">
        <span class="caption">Home</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <!-- PA Schools Button -->
      <v-btn text to="/paschools">
        <span class="caption">Schools</span>
        <v-icon>mdi-school</v-icon>
      </v-btn>

      <!-- School Match Button-->
      <v-btn to="/paschoolfinder" text>
        <span class="caption"> Match</span>
        <v-icon>mdi-target</v-icon>
      </v-btn>

      <!-- Blog Button -->
      <v-btn href="https://blog.mypabox.com/" text >
        <span class="caption">Blog</span>
        <v-icon>mdi-post-outline</v-icon>
      </v-btn>
     
      <!-- Dashboard Button -->
      <v-btn to="/dashboard" text>
        <span class="caption">Dashboard</span>
        <v-icon>mdi-view-dashboard</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-footer class="hidden-sm-and-down footer">
      <v-container>
        <v-row>
          <v-list-item class="footer__linkCover">

            
            <a
              class="footer__listLink"
              target="_blank"
              href="https://docs.google.com/forms/d/e/1FAIpQLSfpjUhFg8S9iltJBan0pgFDG5RpVR1m1oqDpTkmqT3WgCLAqg/viewform?usp=sf_link"
              >Join Our Team</a
            >
            <a
              class="footer__listLink"
              target="_blank"
              href="https://forms.gle/MAzjiGSK75EpJM6d6"
              >Advertise with Us</a
            >
          </v-list-item>
        </v-row>
        <v-row>
          <div class="footer__description">
            myPABox &copy; {{ new Date().getFullYear() }}
          </div>
        </v-row>
      </v-container>
    </v-footer>

    <Announcement />
    <!-- <Competition /> -->
  </v-app>
</template>

<script>
import * as firebase from "firebase";
import { mapGetters } from "vuex";
import UserProfileQuestions from "@/components/User/UserProfileQuestions";
import Competition from "@/components/User/Competition";
import Announcement from "./components/User/Announcement.vue";
// import Competition from '@/components/User/Competition'

export default {
  components: {
    UserProfileQuestions,
    Competition,
    Announcement,
  },
  data() {
    return {
      e1: "",
      menuButton: false,
      bottomNav: "",
      toolbar: false,
      onlySmall: false,
      pageTitle: "",
    };
  },
  methods: {
    showLoginSignUpScreen() {
      this.$router.push("/LoginSignupPage");
    },
    showAccountScreen() {
      this.$router.push("/myaccount");
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(function () {});
      var user = null;
      this.$store.dispatch("logout", user);
    },
  },
  computed: {
    ...mapGetters(["validSubscription", "user"]),
    showMenuBar() {
      if (this.user && this.validSubscription) {
        if (this.user.user_profile == false) return false;
      }
      return true;
    },
    showToolbar() {
      if (this.user && this.validSubscription) {
        if (this.user.user_profile == false) return false;
      }
      return this.toolbar;
    },
    schools() {
      return this.$store.getters.loadedSchools;
    },
    color() {
      switch (this.bottomNav) {
        case 0:
          return "light-blue darken-4";
        case 1:
          return "cyan darken-1";
        case 2:
          return "light-blue darken-3";
        case 3:
          return "teal ";
        case 4:
          return "grey darken-3";
      }
    },
  },
  watch: {
    user(newVal, oldVal) {
      if (newVal !== null && !newVal.subscriptions) {
        if (oldVal && newVal.uid === oldVal.id) return null;
        this.$router.replace("/myaccount");
      }
    },
    $route(to, from) {
      if (to.path === "/") {
        this.pageTitle = "Home";
      }
      if (to.path === "/paschools") {
        this.pageTitle = "PA Schools";
      }
      if (to.path === "/paschoolfinder") {
        this.pageTitle = "PA School Match";
      }
      if (to.path === "/dashboard") {
        this.pageTitle = "My Dashboard";
      }
      if (to.path === "/services") {
        this.pageTitle = "Services";
      }
    },
  },
  mounted() {},
  name: "App",
};
</script>

<style scoped>
@media (max-width: 900px) {
  .content {
    padding-top: 0px !important;
    
  }
}
#toolBar {
  position: fixed;
  margin-bottom: 50px;
  z-index: 2000;
}

.background {
  background-color: #ffffff;
}

.router-link-exact-active {
  color: rgb(48, 112, 231);
}
#create .speed-dial {
  position: absolute;
}

#create .btn--floating {
  position: relative;
}

#buttonShadow {
  -webkit-box-shadow: 0 20px 20px -18px rgba(33, 36, 39, 0.164);
  -moz-box-shadow: 0 20px 20px -18px rgba(33, 36, 39, 0.164);
  box-shadow: 0 20px 20px -18px rgba(33, 36, 39, 0.164);
}

/* Test Master Only */
.v-expansion-panel-content__wrap {
  padding: 10px !important;
}
.logo {
  height: 50px;
}
.iconShortSpace {
  margin-right: 8px !important;
}
.newHeader .v-icon,
.newHeader .v-list-item__title {
  color: #ffffff;
}
.newHeader__link {
  padding-left: 15px;
  text-decoration: none;
}
.newHeader__link:hover .v-icon,
.newHeader__link:hover .v-list-item__title {
  color: #D49129;
}
.actionContainer {
  display: flex;
  flex-direction: row;
}
.flexCont {
  display: flex;
  flex: 1 0 auto;
}
.footer {
  background-color: #ffffff;
}

.footer__title {
  font-size: 16px;
  padding-bottom: 16px;
}

.footer__listItem {
  min-height: auto;
}

.footer__listLink {
  font-size: 14px;
  color: #000000;
  text-decoration: none;
  margin: 0 16px;
  position: relative;
}

.footer__listLink + .footer__listLink::before {
  content: "";
  height: 100%;
  width: 1px;
  background-color: #000000;
  display: block;
  position: absolute;
  top: 0;
  left: -16px;
}
.footer__listLink:hover {
  text-decoration: underline;
}

.footer__socialLink {
  width: 30px;
  height: 30px;
  padding: 8px;
  background-color: #aaaaaa;
  border-radius: 50%;
  margin: 8px 8px 8px 0;
  transition: all 250ms ease-in;
  display: inline-flex;
}
.footer__socialLink:hover {
  margin-top: 0;
  background-color: #cccccc;
}

.footer__socialLink img {
  display: block;
  width: 100%;
}
.footer__description {
  text-align: center;
  font-size: 12px;
  width: 100%;
}
.footer__linkCover {
  display: flex;
  text-align: center;
  width: 100%;
  justify-content: center;
  border-top: 1px solid #dddddd;
}
</style>
<style>
.v-expansion-panel-content__wrap {
  padding-left: 10px !important;
  padding-right: 10px !important;
  width: 100%;
}

.v-list-item__title {
  /* white-space: normal; */
}
@media (max-width: 767px) {
  .v-item-group.v-bottom-navigation .v-btn {
    min-width: 70px;
  }

  .caption {
    /* white-space: normal; */
    /* width: 60px; */
    /* text-align: center; */
  }
}

#headerStyle {
  background-image: linear-gradient( #005880, #192653);
}

.white {
  margin-top:0;
 padding-top: 0px !important;
}

.logo{
 width: 75%;
 padding: 0;
}

#loadingLogo {
  width:35%;
}

.mobile__toolbar {
  background-image: linear-gradient( #005880, #192653);
}


</style>



// WEBPACK FOOTER //
// src/App.vue